"use strict";
import React from "react";
import _ from "underscore";
import ReactUtils from "../react_utils";
var bem = ReactUtils.makeBem("carrier-labels");
const removeDuplicates = (list) => [...new Set(list)];
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("", this.props.className) }, removeDuplicates(this.props.labels).map(this.label), this.editLink());
  },
  label: function(label) {
    var labelName = this.labelName(label);
    return /* @__PURE__ */ React.createElement("div", { className: bem("__label"), key: labelName }, labelName);
  },
  labelName: function(label) {
    var ret = label.name || label;
    if (ret && _.isString(ret)) {
      return ret;
    } else {
      throw "Invalid label. Label needs to be a string or an object with a non-null name member. Label was" + label;
    }
  },
  editLink: function() {
    if (this.props.onEdit) {
      return /* @__PURE__ */ React.createElement("div", { className: bem("__buttons") }, /* @__PURE__ */ React.createElement("a", { onClick: this.props.onEdit }, "Edit ..."));
    }
  }
});
